<template>
  <div class="teachers" v-if="data">
    <div class="teachers__item">
      <div class="teachers__item__attr">
        <span class="teachers__item__name">{{ computedName(data.name) }}</span>
        <!-- <span class="teachers__item__hr"></span>
        <span class="teachers__item__subject">{{ data.subjectNames }}</span> -->
      </div>
      <div class="teachers__item__info" v-if="data.courseNum">
        当前在售{{ data.courseNum }}期课程
      </div>
      <a
        class="teachers__item__enter"
        target="_blank"
        :href="`//online.xueersi.com/t/${data.id}`"
        @click="handClick({ clickurl: `online.xueersi.com/t/${data.id}` }, $event, data)"
        >个人主页</a
      >
    </div>
    <div class="teachers__img" :style="{ backgroundImage: `url(${data.avatar})` }"></div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  props: ['data'],
  data() {
    return {}
  },
  computed: {
    ...mapState({
      chooseSift: state => state.SearchPage.chooseSift,
      siftName: state => state.SearchPage.siftName,
      dataExpTag: state => state.SearchPage.dataExpTag
    }),
    keyword() {
      const { keyword = '' } = this.$route.query
      return keyword
    }
  },
  methods: {
    computedName(name) {
      // eslint-disable-next-line no-control-regex
      var r = /[^\x00-\xff]/g
      if (name.replace(r, 'mm').length <= 8) {
        return name
      }
      var m = Math.floor(8 / 2)
      for (var i = m; i < name.length; i++) {
        if (
          name.substr(0, i).replace(r, 'mm').length >= 8 &&
          name.substr(0, i).replace(r, 'mm').length < 9
        ) {
          return name.substr(0, i) + '...'
        }
        if (name.substr(0, i).replace(r, 'mm').length === 9) {
          return name.substr(0, i - 1) + '...'
        }
      }
      return name
    },
    handClick(data, event) {
      this.xesLog(data, event)
    },
    xesLog({ clickurl = '' }, event) {
      const XESLog = new this.$XESLog({
        key: 'xeslog-searchTeacherClick-www',
        clickid: '1.4.27',
        clickurl: clickurl,
        teacherid: this.data.id,
        teachername: this.data.name,
        subjectid: this.data.subjectNames,
        salenum: this.data.courseNum,
        sorttype: this.$route.query.sort ? this.$route.query.sort : 1,
        setgradeid: this.$store.state.cookies.userGrade,
        curgradeid: this.$store.state.cookies.currentGrade,
        query: this.keyword,
        exp_tag: this.dataExpTag
      })
      XESLog.push({ eventname: 'click', target: event.target }, this.$route)
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'src/scss/entry';
@include b(teachers) {
  width: 100%;
  height: 240px;
  background: url(../images/teacher-bg.png) no-repeat;
  overflow: hidden;
  position: relative;
  text-align: right;
  margin-top: 20px;
  @include e(img) {
    display: inline-block;
    width: 220px;
    height: 210px;
    overflow: hidden;
    margin-top: 30px;
    margin-right: 388px;
    background-size: cover;
    vertical-align: middle;
    background-repeat: no-repeat;
  }
  @include e(item) {
    position: absolute;
    right: 752px;
    top: 76px;
    text-align: left;
    @include e(attr) {
      & > span {
        color: #333333;
        font-size: 28px;
        font-weight: bold;
        display: inline-block;
        vertical-align: middle;
      }
    }
    @include e(name) {
      max-width: 168px;
      overflow: hidden;
      // text-overflow: ellipsis;
      white-space: nowrap;
    }
    @include e(hr) {
      border-left: 1px solid #333333;
      height: 26px;
      margin: 0 16px;
      opacity: 0.2;
    }
    @include e(info) {
      color: #666666;
      font-size: 16px;
      line-height: 16px;
      margin-top: 12px;
    }
    @include e(subject) {
    }
    @include e(enter) {
      box-sizing: border-box;
      margin-top: 24px;
      display: block;
      width: 146px;
      height: 32px;
      text-align: center;
      border: 1px solid #c1c7db;
      font-size: 14px;
      color: #666666;
      line-height: 30px;
      border-radius: 2px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// ./src/views/SearchPage/components/Teacher.vue